import {
  CalendarToday,
  LocationSearching,
  MailOutline,
  PermIdentity,
  PhoneAndroid,
  Publish,
} from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";
import "./user.css";
const User = () => {
  return (
    <div className="user">
      <div className="user_title_container">
        <h1 className="user_title">Edit User</h1>
        <Link to="/new_user">
          <button className="user_add_button">Create</button>
        </Link>
      </div>

      <div className="user_container">
        <div className="user_show">
          <div className="user_show_top">
            <img
              src="https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt=""
              className="user_show_img"
            />

            <div className="user_show_top_title">
              <span className="user_show_userName">Anna lary</span>
              <span className="user_show_userTitle">Web Developer</span>
            </div>
          </div>

          <div className="user_show_button">
            <span className="user_show_title">Account Detail</span>
            <div className="user_show_info">
              <PermIdentity className="user_show_icon" />
              <span className="user_show_info_title">annabeck007</span>
            </div>
            <div className="user_show_info">
              <CalendarToday className="user_show_icon" />
              <span className="user_show_info_title">1 june 1995</span>
            </div>

            <span className="user_show_title">Contact Detail</span>
            <div className="user_show_info">
              <PhoneAndroid className="user_show_icon" />
              <span className="user_show_info_title">+ 66 00 4453 345</span>
            </div>
            <div className="user_show_info">
              <MailOutline className="user_show_icon" />
              <span className="user_show_info_title">
                annabeck007@gmail.com
              </span>
            </div>
            <div className="user_show_info">
              <LocationSearching className="user_show_icon" />
              <span className="user_show_info_title">Bangkok | Thailand</span>
            </div>
          </div>
        </div>

        <div className="user_update">
          <span className="user_update_title">Edit</span>
          <form action="" className="user_update_form">
            <div className="user_update_left">
              <div className="user_update_left_item">
                <label>Username</label>
                <input
                  type="text"
                  className="user_update_input"
                  placeholder="annabeck007"
                />
              </div>
              <div className="user_update_left_item">
                <label>Full name</label>
                <input
                  type="text"
                  className="user_update_input"
                  placeholder="Anna lary"
                />
              </div>
              <div className="user_update_left_item">
                <label>Email</label>
                <input
                  type="text"
                  className="user_update_input"
                  placeholder="annabeck007"
                />
              </div>
              <div className="user_update_left_item">
                <label>Phone</label>
                <input
                  type="text"
                  className="user_update_input"
                  placeholder="annabeck007"
                />
              </div>
              <div className="user_update_left_item">
                <label>Address</label>
                <input
                  type="text"
                  className="user_update_input"
                  placeholder="annabeck007"
                />
              </div>
            </div>

            <div className="user_update_right">
              <div className="user_update_upload">
                <img
                  src="https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                  alt=""
                  className="user_update_img"
                />
                <label htmlFor="file">
                  <Publish className="user_update_icon" />
                </label>
                <input type="file" id="file" style={{ display: "none" }} />
              </div>
              <button className="user_update_button">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default User;
